
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M27.46 21.16L19.79 8.48c-.19-.3-.51-.48-.86-.48h-4.87c-.55 0-1 .45-1 1s.45 1 1 1h4.31l6.75 11.16H12.64a1 1 0 00-.96.7 15.398 15.398 0 00-.586 6.228c.812 7.309 6.805 13.07 14.206 13.532v9.02h-3.94c-.55 0-1 .45-1 1s.45 1 1 1h9.88c.55 0 1-.45 1-1s-.45-1-1-1H27.3v-9.025c6.079-.412 11.192-4.406 13.25-9.88 4.968-.365 8.89-4.523 8.89-9.575 0-5.29-4.31-9.6-9.6-9.6-4.956 0-9.051 3.774-9.55 8.6h-2.83zm-14.07 2a13.478 13.478 0 00-.397 3.529c4.328-.954 8.835-1.226 12.507-.749 6.546.86 11.834.524 14.002-.029a12.892 12.892 0 00-.392-2.751H13.39zm26.025 4.82c-2.868.578-8.154.733-14.175-.05-3.527-.468-7.868-.183-12.05.765 1.095 6.216 6.536 10.955 13.06 10.955 6.772 0 12.377-5.106 13.165-11.67zm-7.11-6.82h7.575c.44 0 .83.29.96.7.45 1.46.68 2.99.68 4.53a15.268 15.268 0 01-.353 3.254c3.56-.63 6.273-3.747 6.273-7.484 0-4.19-3.41-7.6-7.6-7.6-3.854 0-7.048 2.885-7.536 6.6z"}})])
          )
        }
      }
    